<template>
  <div>
    <!-- Barra de búsqueda -->
    <div class="card mb-3">
      <div class="card-body">
        <div class="row align-items-end">
          <div class="col-md-6">
            <label class="mb-1 small text-muted">Buscar tramos:</label>
            <input
              type="text"
              class="form-control form-control-sm"
              v-model="busqueda"
              @keyup.enter="buscarTramos()"
              placeholder="Buscar tramos de rutas..."
            />
          </div>
          <div class="col-md-3">
            <label class="mb-1 small text-muted">Distancia máxima (Km):</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model.number="distanciaMaximaKm"
              @blur="validarDistanciaMaxima"
              @change="validarYFiltrar"
              min="1"
              max="50"
              step="1"
            />
          </div>
          <div class="col-md-3">
            <button
              type="button"
              class="btn btn-primary btn-sm w-100"
              @click="buscarTramos()"
            >
              <i class="fas fa-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Lista de tramos añadidos -->
    <div class="card mb-3" v-if="tramosAñadidos.length > 0">
      <div class="card-header bg-info">
        <h5 class="mb-0 text-white">Tramos Añadidos ({{ tramosAñadidos.length }})</h5>
      </div>
      <div class="card-body p-0">
        <div class="list-group list-group-flush">
          <div
            v-for="(tramo, index) in tramosAñadidos"
            :key="tramo.id"
            class="list-group-item d-flex justify-content-between align-items-center"
            :class="{'bg-light': index === tramosAñadidos.length - 1}"
          >
            <div>
              <span class="badge badge-primary mr-2">{{ index + 1 }}</span>
              <span>{{ tramo.nombre }}</span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-danger"
              @click="eliminarTramo(index)"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-footer" v-if="cadenaCompleta">
        <button
          type="button"
          class="btn btn-success btn-block"
          @click="guardarCadenaTramos()"
        >
          <i class="fas fa-save"></i> Guardar Cadena de Tramos
        </button>
      </div>
    </div>

    <!-- Lista de tramos -->
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">Tramos Disponibles</h5>
      </div>
      <div class="card-body p-0">
        <loading v-if="cargando" />
        <div v-else>
          <div v-if="tramosFiltrados.length === 0" class="p-3 text-center">
            <span class="badge badge-warning">
              No hay tramos para mostrar
            </span>
          </div>
          <div v-else class="list-group list-group-flush">
            <div
              v-for="tramo in tramosFiltrados"
              :key="tramo.id"
              class="list-group-item d-flex justify-content-between align-items-center"
            >
              <span>{{ tramo.nombre }}</span>
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="añadirTramo(tramo)"
              >
                <i class="fas fa-plus"></i> Añadir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
import axios from "axios";

const google = window.google;

export default {
  name: "CsTramosRutas",
  components: {
    loading,
  },
  data() {
    return {
      cargando: false,
      busqueda: "",
      tramos: [],
      tramosFiltrados: [],
      puntoReferencia: null, // Punto de referencia para filtrar (destino del último tramo añadido o origen de la ruta)
      tramosAñadidos: [], // Lista de tramos añadidos al mapa
      distanciaMaximaKm: 50, // Distancia máxima configurable en km
      toleranciaUnion: 100, // Tolerancia en metros para considerar que dos puntos están unidos (100m = 0.1km)
      cadenaCompleta: false, // Estado de si la cadena está completa
    };
  },
  methods: {
    obtenerCoordenadasRuta(ruta, tipo) {
      // tipo puede ser 'origen' o 'destino'
      if (!ruta) return null;

      let lat = null;
      let lng = null;

      if (tipo === 'origen') {
        // Prioridad 1: Buscar en lat_origen/lng_origen directos
        if (ruta.lat_origen && ruta.lng_origen) {
          lat = parseFloat(ruta.lat_origen);
          lng = parseFloat(ruta.lng_origen);
        }
        // Prioridad 2: Buscar en la relación origen
        else if (ruta.origen) {
          const origen = ruta.origen;
          const latValue = origen.latitud || origen.lat || origen.lat_origen;
          const lngValue = origen.longitud || origen.lng || origen.lng_origen || origen.lon;
          if (latValue && lngValue) {
            lat = parseFloat(latValue);
            lng = parseFloat(lngValue);
          }
        }
      } else if (tipo === 'destino') {
        // Prioridad 1: Buscar en lat_destino/lng_destino directos
        if (ruta.lat_destino && ruta.lng_destino) {
          lat = parseFloat(ruta.lat_destino);
          lng = parseFloat(ruta.lng_destino);
        }
        // Prioridad 2: Buscar en la relación destino
        else if (ruta.destino) {
          const destino = ruta.destino;
          const latValue = destino.latitud || destino.lat || destino.lat_destino;
          const lngValue = destino.longitud || destino.lng || destino.lng_destino || destino.lon;
          if (latValue && lngValue) {
            lat = parseFloat(latValue);
            lng = parseFloat(lngValue);
          }
        }
      }

      return lat && lng ? { lat, lng } : null;
    },
    validarDistanciaMaxima() {
      // Si el campo está vacío, null o undefined, establecer el valor por defecto
      if (this.distanciaMaximaKm === null || this.distanciaMaximaKm === undefined || this.distanciaMaximaKm === '') {
        this.distanciaMaximaKm = 50; // Establecer valor por defecto solo cuando el usuario sale del campo
        return;
      }
      
      // Convertir a número si es necesario
      const valor = parseFloat(this.distanciaMaximaKm);
      
      if (isNaN(valor)) {
        this.distanciaMaximaKm = 50; // Valor por defecto si no es un número válido
        return;
      }
      
      if (valor > 50) {
        this.distanciaMaximaKm = 50;
        this.$swal({
          icon: "warning",
          title: "Distancia máxima permitida",
          text: "La distancia máxima no puede ser mayor a 50 km",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else if (valor < 1) {
        // Solo establecer a 1 si el valor es menor a 1 y es un número válido
        this.distanciaMaximaKm = 1;
      }
    },
    validarYFiltrar() {
      this.validarDistanciaMaxima();
      this.filtrarTramosCercanos();
    },
    buscarTramos() {
      this.cargando = true;
      axios
        .get("/api/cs/tramosRutas", {
          params: {
            nombre: this.busqueda || null,
          },
        })
        .then((response) => {
          this.tramos = response.data.data || [];
          this.filtrarTramosCercanos();
          this.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    obtenerPuntoReferencia() {
      // Si hay tramos añadidos, usar el destino del último tramo añadido
      if (this.tramosAñadidos.length > 0) {
        const ultimoTramo = this.tramosAñadidos[this.tramosAñadidos.length - 1];
        if (ultimoTramo.lat_destino && ultimoTramo.lng_destino) {
          this.puntoReferencia = {
            lat: parseFloat(ultimoTramo.lat_destino),
            lng: parseFloat(ultimoTramo.lng_destino),
          };
          return;
        }
      }

      // Si no hay tramos añadidos, usar el origen de la ruta
      const rutaDetalle = this.$parent;
      if (rutaDetalle && rutaDetalle.ruta) {
        const ruta = rutaDetalle.ruta;
        const origenRuta = this.obtenerCoordenadasRuta(ruta, 'origen');

        if (origenRuta) {
          this.puntoReferencia = origenRuta;
        }
      }
    },
    calcularDistancia(origen, destino) {
      if (!origen || !destino || !destino.lat || !destino.lng) {
        return Infinity; // Retornar distancia muy grande si no hay coordenadas
      }
      return google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(origen.lat, origen.lng),
        new google.maps.LatLng(destino.lat, destino.lng)
      );
    },
    filtrarTramosCercanos() {
      // Asegurarse de obtener el punto de referencia si no está disponible
      if (!this.puntoReferencia) {
        this.obtenerPuntoReferencia();
      }

      // Si aún no hay punto de referencia, mostrar todos los tramos
      if (!this.puntoReferencia) {
        // Filtrar solo los que ya fueron añadidos
        this.tramosFiltrados = this.tramos.filter(
          (tramo) => !this.tramosAñadidos.find((ta) => ta.id === tramo.id)
        );
        return;
      }

      // Filtrar tramos que ya fueron añadidos
      const tramosDisponibles = this.tramos.filter(
        (tramo) => !this.tramosAñadidos.find((ta) => ta.id === tramo.id)
      );

      // Calcular distancia de cada tramo al punto de referencia (destino del último tramo o origen de ruta)
      const tramosConDistancia = tramosDisponibles
        .filter((tramo) => {
          // Verificar que el tramo tenga coordenadas válidas
          return tramo.lat_origen && tramo.lng_origen &&
                 !isNaN(parseFloat(tramo.lat_origen)) &&
                 !isNaN(parseFloat(tramo.lng_origen));
        })
        .map((tramo) => {
          const origenTramo = {
            lat: parseFloat(tramo.lat_origen),
            lng: parseFloat(tramo.lng_origen),
          };

          const distancia = this.calcularDistancia(
            this.puntoReferencia,
            origenTramo
          );

          return {
            ...tramo,
            distanciaAlOrigen: distancia, // distancia en metros
          };
        });

      // Filtrar tramos que están dentro de la distancia máxima configurable
      const distanciaMaximaMetros = this.distanciaMaximaKm * 1000;
      this.tramosFiltrados = tramosConDistancia
        .filter((tramo) => tramo.distanciaAlOrigen <= distanciaMaximaMetros)
        .sort((a, b) => a.distanciaAlOrigen - b.distanciaAlOrigen);
    },
    verificarUnionLogica(tramoAnterior, tramoSiguiente) {
      if (!tramoAnterior || !tramoSiguiente) return false;
      
      // Obtener el destino del tramo anterior
      const destinoAnterior = {
        lat: parseFloat(tramoAnterior.lat_destino),
        lng: parseFloat(tramoAnterior.lng_destino),
      };
      
      // Obtener el origen del tramo siguiente
      const origenSiguiente = {
        lat: parseFloat(tramoSiguiente.lat_origen),
        lng: parseFloat(tramoSiguiente.lng_origen),
      };
      
      // Calcular la distancia en línea recta
      const distanciaLineaRecta = this.calcularDistancia(destinoAnterior, origenSiguiente);
      
      // Si la distancia es muy pequeña (menos de 10 metros), considerarla como el mismo punto
      if (distanciaLineaRecta < 10) {
        return true;
      }
      
      // Calcular la ruta real usando DirectionsService para verificar si hay alternativa
      return new Promise((resolve) => {
        const directionsService = new google.maps.DirectionsService();
        const request = {
          origin: destinoAnterior,
          destination: origenSiguiente,
          travelMode: google.maps.TravelMode.DRIVING,
        };
        
        directionsService.route(request, (result, status) => {
          if (status === google.maps.DirectionsStatus.OK && result.routes.length > 0) {
            // Obtener la distancia de la ruta calculada
            const distanciaRuta = result.routes[0].legs[0].distance.value; // en metros
            
            // Calcular la diferencia entre la ruta real y la línea recta
            const diferencia = distanciaRuta - distanciaLineaRecta;
            const porcentajeDiferencia = (diferencia / distanciaLineaRecta) * 100;
            
            // Si la diferencia es mayor al 5%, significa que hay un desvío/alternativa (no es línea recta)
            // En este caso, validar que la distancia esté dentro de los 100m
            if (porcentajeDiferencia > 5) {
              // Hay ruta alternativa, validar los 100m
              resolve(distanciaLineaRecta <= this.toleranciaUnion);
            } else {
              // Es prácticamente línea recta, no validar distancia
              resolve(true);
            }
          } else {
            // Si no se puede calcular la ruta, permitir la unión si está dentro de la tolerancia
            resolve(distanciaLineaRecta <= this.toleranciaUnion);
          }
        });
      });
    },
    async verificarCadenaCompleta() {
      if (this.tramosAñadidos.length === 0) {
        this.cadenaCompleta = false;
        return false;
      }
      
      // Verificar que todos los tramos estén conectados lógicamente
      for (let i = 0; i < this.tramosAñadidos.length - 1; i++) {
        const tramoActual = this.tramosAñadidos[i];
        const tramoSiguiente = this.tramosAñadidos[i + 1];
        
        const puedeUnirse = await this.verificarUnionLogica(tramoActual, tramoSiguiente);
        if (!puedeUnirse) {
          this.cadenaCompleta = false;
          return false;
        }
      }
      
      // Verificar que el primer tramo empiece en el origen de la ruta
      const rutaDetalle = this.$parent;
      if (rutaDetalle && rutaDetalle.ruta) {
        const ruta = rutaDetalle.ruta;
        const origenRuta = this.obtenerCoordenadasRuta(ruta, 'origen');
        
        if (origenRuta) {
          const primerTramo = this.tramosAñadidos[0];
          const origenPrimerTramo = {
            lat: parseFloat(primerTramo.lat_origen),
            lng: parseFloat(primerTramo.lng_origen),
          };
          const distanciaInicio = this.calcularDistancia(origenRuta, origenPrimerTramo);
          // Para el origen y destino de la ruta, siempre validar los 100m
          if (distanciaInicio > this.toleranciaUnion) {
            this.cadenaCompleta = false;
            return false;
          }
        }
      }
      
      // Verificar que el último tramo termine en el destino de la ruta
      if (rutaDetalle && rutaDetalle.ruta) {
        const ruta = rutaDetalle.ruta;
        const destinoRuta = this.obtenerCoordenadasRuta(ruta, 'destino');
        
        if (destinoRuta) {
          const ultimoTramo = this.tramosAñadidos[this.tramosAñadidos.length - 1];
          const destinoUltimoTramo = {
            lat: parseFloat(ultimoTramo.lat_destino),
            lng: parseFloat(ultimoTramo.lng_destino),
          };
          const distanciaFin = this.calcularDistancia(destinoRuta, destinoUltimoTramo);
          // Para el origen y destino de la ruta, siempre validar los 100m
          if (distanciaFin > this.toleranciaUnion) {
            this.cadenaCompleta = false;
            return false;
          }
        }
      }
      
      this.cadenaCompleta = true;
      return true;
    },
    async añadirTramo(tramo) {
      // Si ya hay tramos añadidos, verificar que el nuevo tramo se pueda unir al último
      if (this.tramosAñadidos.length > 0) {
        const ultimoTramo = this.tramosAñadidos[this.tramosAñadidos.length - 1];
        const puedeUnirse = await this.verificarUnionLogica(ultimoTramo, tramo);
        
        if (!puedeUnirse) {
          this.$swal({
            icon: "warning",
            title: "No se puede añadir este tramo",
            text: `El origen de este tramo está a más de ${this.toleranciaUnion}m del destino del tramo anterior. La distancia debe ser menor para poder unirlos cuando hay una ruta alternativa.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
          return;
        }
      } else {
        // Si es el primer tramo, verificar que empiece cerca del origen de la ruta
        const rutaDetalle = this.$parent;
        if (rutaDetalle && rutaDetalle.ruta) {
          const ruta = rutaDetalle.ruta;
          const origenRuta = this.obtenerCoordenadasRuta(ruta, 'origen');
          if (origenRuta) {
            const origenTramo = {
              lat: parseFloat(tramo.lat_origen),
              lng: parseFloat(tramo.lng_origen),
            };
            const distancia = this.calcularDistancia(origenRuta, origenTramo);
            if (distancia > this.toleranciaUnion) {
              this.$swal({
                icon: "warning",
                title: "No se puede añadir este tramo",
                text: `El origen de este tramo está a más de ${this.toleranciaUnion}m del origen de la ruta. Debe empezar cerca del origen de la ruta.`,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
              return;
            }
          }
        }
      }

      // Obtener los datos completos del tramo desde la API
      axios
        .get(`/api/cs/tramosRutas/${tramo.id}`)
        .then((response) => {
          const tramoCompleto = response.data;
          this.tramosAñadidos.push(tramoCompleto);

          // Notificar al componente padre para pintar el tramo en el mapa
          if (this.$parent && this.$parent.pintarTramoEnMapa) {
            this.$parent.pintarTramoEnMapa(tramoCompleto);
          }

          // Resetear la lista de tramos y filtrar nuevamente usando el destino del tramo añadido
          this.puntoReferencia = null;
          this.filtrarTramosCercanos();
          
          // Verificar la cadena completa después de añadir
          this.verificarCadenaCompleta();
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error al cargar el tramo: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    eliminarTramo(index) {
      this.$swal({
        title: "¿Está seguro de eliminar este tramo?",
        text: "Se eliminará de la cadena y todos los tramos siguientes también se eliminarán",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          // Eliminar el tramo y todos los siguientes
          this.tramosAñadidos.splice(index);
          
          // Notificar al padre para actualizar el mapa
          if (this.$parent && this.$parent.eliminarTramosDesde) {
            this.$parent.eliminarTramosDesde(index);
          }
          
          // Resetear y filtrar nuevamente
          this.puntoReferencia = null;
          this.filtrarTramosCercanos();
          
          // Verificar la cadena completa después de eliminar
          this.verificarCadenaCompleta();
        }
      });
    },
    guardarCadenaTramos() {
      if (!this.cadenaCompleta) {
        this.$swal({
          icon: "warning",
          title: "La cadena no está completa",
          text: "Todos los tramos deben estar conectados correctamente y la cadena debe llegar al destino de la ruta.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }

      this.$swal({
        title: "¿Está seguro de guardar esta cadena de tramos?",
        text: `Se guardarán ${this.tramosAñadidos.length} tramos conectados en secuencia.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Guardar!",
      }).then((result) => {
        if (result.value) {
          // Notificar al componente padre para guardar la cadena
          if (this.$parent && this.$parent.guardarCadenaTramos) {
            this.$parent.guardarCadenaTramos(this.tramosAñadidos);
          }
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.obtenerPuntoReferencia();
      this.buscarTramos();

      // Intentar obtener el punto de referencia cada 500ms hasta 5 segundos
      let attempts = 0;
      const maxAttempts = 10;
      const interval = setInterval(() => {
        attempts++;
        this.obtenerPuntoReferencia();

        if (this.puntoReferencia || attempts >= maxAttempts) {
          clearInterval(interval);
          if (this.tramos.length > 0) {
            this.filtrarTramosCercanos();
          }
        }
      }, 500);
    });
  },
  watch: {
    // Observar cambios en la ruta del padre
    "$parent.ruta": {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.obtenerPuntoReferencia();
            if (this.tramos.length > 0) {
              this.filtrarTramosCercanos();
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
    // Observar cambios en los tramos añadidos para verificar la cadena
    tramosAñadidos: {
      handler() {
        // Verificar la cadena cuando cambien los tramos añadidos
        this.verificarCadenaCompleta();
      },
      deep: true,
    },
  },
};
</script>
